export default __webpack_public_path__ + "static/media/37.a0bdfe6a.jpeg";